import { ReactNode } from 'react';
import { useIsMobile } from 'src/hooks/useIsMobile';
import LoginContainerHeader from './components/LoginContainerHeader';
import LoginContainerModal from './components/LoginContainerModal';
import {
  ContentContainer,
  LoginContainerModalWrapper,
  PageContainer,
} from './LoginPageLayout.styles';

export const LoginPageLayout = (props: {
  header: ReactNode;
  children: ReactNode;
  footer: ReactNode;
  actionButton?: ReactNode;
}) => {
  const isMobile = useIsMobile();

  return (
    <PageContainer>
      {!isMobile && <LoginContainerHeader logoComponent={props.header} />}
      <ContentContainer>
        <LoginContainerModal>
          {isMobile && <LoginContainerHeader logoComponent={props.header} />}
          <LoginContainerModalWrapper>
            {props.children}
          </LoginContainerModalWrapper>
        </LoginContainerModal>
        {props.actionButton ?? <></>}
      </ContentContainer>
      {!isMobile && props.footer}
    </PageContainer>
  );
};
